// removed by extract-text-webpack-plugin
module.exports = {"form":"_13BNz","select":"_1SKlP","optionValue":"_1QXQq","slider":"Ak9vL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/present/PresentOptionsForm.css
// module id = 839
// module chunks = 0